import angular from 'angular';

export default angular.module('components.serails2', [])
    .component('serials2', {
        template: require('./serials2.pug')(),
        controller: ['ZebraService', '$state', 'Serials2Config', function(ZebraService, $state, Serials2Config) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.catalogid = Serials2Config.catalogid;
            };
            ctrl.getTerms = function(val) {
                var params = {};
                params.id = 7;
                params.operation = 'scan';
                params.scanClause = 'cuba.title="' + val  + '"';
                params.responePosition = 1;
                return ZebraService.get(params).$promise.then(function(response) {
                    return response.terms.map(function(item){
                        return item.displayTerm.replace(/(^\s+|\s+$)/g, '');
                    });
                });
            };

            ctrl.callSearch = function() {
                return $state.go('serials2.titles', {startWith: ctrl.query.freetext, pos:1});
            };

            ctrl.callReset = function() {
                ctrl.query.freetext = null;
            };
        }]
    })
    //.component('serials2IndexLink', {
    //    bindings: {
    //        index: '<',
    //        onToggleActive: '&'
    //    },
    //    template: require('./serials2IndexLink.pug')()
    //})
    .component('serials2Detail', {
        bindings: {
            startWith: '<',
            pos: '<'
        },
        template: require('./serials2Detail.pug')(),
        controller: [ 'ZebraService', function(ZebraService) {
            var ctrl = this;

            ctrl.max = 10;
            ctrl.pos = 1;

            ctrl.toggleActive = function(titleValue) { 
                //var title = ctrl.response.terms.find(t => t.value == titleValue);
                //if (!title) return;
                //title.active = !title.active;
                angular.forEach(ctrl.response.terms, function(t) {
                    t.active = t.value == titleValue;
                });
            };

            ctrl.$onInit = function() {
                ctrl.callScan(ctrl.startWith, ctrl.pos);
            };

            ctrl.callScan =  function(term, pos) {
                console.log('callScan()', term, pos);
                if (term) {
                    ctrl.loading = true;
                    scan(7, 'cuba.title', term, pos, ctrl.max,  function(err, response) {
                        ctrl.loading = false;
                        if (err) {
                            ctrl.error = err.message || err;
                        }
                        ctrl.response = response;
                        if (ctrl.response && ctrl.response.terms) {
                            var size = ctrl.response.terms.length;
                            if (size > 0) {
                                ctrl.next_term = ctrl.response.terms[size-1].value;
                                ctrl.next_pos = 1;
                            }
                            if (size > 1) {
                                ctrl.prev_term = ctrl.response.terms[0].value;
                                ctrl.prev_pos = size;
                            }
                        }
                    });
                }
            };

            function scan(id, index, term, pos, max, done) {
                var params = {};
                params.id = id;
                params.operation = 'scan';
                params.scanClause = index + '="^' + term.replace(/\\"/g, '\\"') +'"';
                    params.maximumTerms = max;
                    params.responsePosition = pos;
                    console.log(params);
                    ZebraService.get(params).$promise.then(function(response) {
                        done(null, response);
                    }, function(err) {
                        done(err, null);
                    });
            }
        }]
    })
    .component('serials2TitleLink', {
        bindings: {
            title: '<',
            onToggleActive: '&'
        },
        template: require('./serials2TitleLink.pug')(),
    })
    .component('serials2TitleDetail', {
        bindings: {
            title: '<'
        },
        template: require('./serials2TitleDetail.pug')(),
        controller: [ 'ZebraService', function(ZebraService) {
            var ctrl = this;
            ctrl.toggleActive = function(yearTerm) { 
                //var year = ctrl.years.find(y => y.term == yearTerm);
                //
                //if (!year) return;
                //year.active = !year.active;
                console.log(ctrl.response.rsn);
                angular.forEach(ctrl.response.rsn, function(t) {
                    t.active = t.term == yearTerm;
                });
 
            };

            ctrl.$onInit = function() {
                ctrl.callRSN("cuba.title=\""+ctrl.title+"\"");
            };

            ctrl.callRSN = function(query) {
                if (query) {
                    ctrl.loading = true;
                    RSN(query,  function(err, response) {
                        ctrl.loading = false;
                        if (err) {
                            ctrl.error = err.message || err;
                        }
                        ctrl.response = response;
                    });
                }
            };

            function RSN(query, done) {
                var qs  = {
                    id: 7,
                    operation: 'search',
                    query: query,
                    recordSchema: 'marcxml',
                    maximumRecords: 0,
                    facetsEnable: 0,
                    rsnEnable: 1,
                    extraRequestData: 'cuba.dateNarrow=2023' 
                };
                console.log('RSN()', qs);
                ZebraService.get(qs).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }
        }]
    })
    .component('serials2YearLink', {
        bindings: {
            year: '<',
            onToggleActive: '&'
        },
        template: require('./serials2YearLink.pug')(),
    })
    .component('serials2YearDetail', {
        bindings: {
            year: '<',
            title: '<'
        },
        template: require('./serials2YearDetail.pug')(),
        controller: ['ZebraService', function(ZebraService) {
            var ctrl = this;
            ctrl.toggleActive = function(docValue) { 
                var doc = ctrl.docs.find(d => d.value == docValue);
                if (!doc) return;
                doc.active = !doc.active;
            };

            ctrl.$onInit = function() {
                ctrl.callSearch("cuba.title=\""+ctrl.title+"\" and dc.date=\""+ ctrl.year +"\"");
            };

            ctrl.callSearch = function(query) {
                if (query) {
                    ctrl.loading = true;
                    search(query, 1, 50, 'bibv1.1',  function(err, response) {
                        ctrl.loading = false;
                        if (err) {
                            ctrl.error = err.message || err;
                        }
                        ctrl.response = response;
                        ctrl.docs = response.records;
                    });
                }
            };

            function search(query, start, max, schema, done) {
                var qs  = {
                    id: 7,
                    operation: 'search',
                    query: query,
                    recordSchema: schema,
                    maximumRecords: max,
                    startRecord: start
                };
                console.log('search()', qs);
                ZebraService.get(qs).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }
 
        }]
    })
    .component('serials2DocLink', {
        bindings: {
            doc: '<',
        },
        template: require('./serials2DocLink.pug')(),
    })
    .component('serials2DocDetail', {
        bindings: {
            doc: '<'
        },
        template: require('./serials2DocDetail.pug')(),
        controller: ['AuthenticationService', 'Serials2Config', function(AuthenticationService, Serials2Config) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.isAuthenticated = AuthenticationService.isAuthenticated();
                ctrl.sortKeysList= Serials2Config.sortKeysList;
            };
        }]
    })
    .value('Serials2Config', {
        catalogid: 7,
        sortKeysList: [
            //{name: __('Publication date (new)'), value:'cql.sortByDateDescending=0'},
            //{name: __('Publication date (old)'), value:'cql.sortByDateAscending=0'},
            {name: __('Relevant'), value:''},
            //{name: 'РелевRecord key ue:'cql.sortByRecordLinkingAscending=0'},
            {name: __('Author (A-Z)'), value:'cql.sortByAuthorAscending=0', glyphicon: 'glyphicon glyphicon-sort-by-alphabe'},
            {name: __('Author (Z-A)'), value:'cql.sortByAuthorDescending=0', grlyphicon: 'glyphicon glyphicon-sort-by-alphabet-alt'},
            {name: __('Record key (ascending)'), value:'cql.sortByLocalNumberAscending=0'},
            {name: __('Record key (descending)'), value:'cql.sortByLocalNumberDescending=0'},
        ]
    })
    .name;
